/**
 * Common utility functions
 * Provides UUID generation, JSON parsing, money formatting, and global state access
 */

import { v4 as uuidv4 } from 'uuid'

function generateID() {
  return uuidv4()
}

function parseJSON(input: string | object, defaultReturnType = 'object') {
  if (typeof input === 'object') return input
  if (!input) return defaultReturnType === 'object' ? {} : []
  try {
    return JSON.parse(input.replace(/(&quot;)/g, '"'))
  } catch (err) {
    console.error('Could not parse input in parseJSON.', parseJSON, err)
    return defaultReturnType === 'object' ? {} : []
  }
}

const globalState = window.globals

export {
  globalState,
  parseJSON,
  generateID
}
